// extracted by mini-css-extract-plugin
module.exports = {"newsWrapper":"AllNews_newsWrapper__AIq1C","adjustedPosition":"AllNews_adjustedPosition__SYNiJ","infoWrapper":"AllNews_infoWrapper__ou2_g"};